<script setup></script>

<template>
  <nav class="navbar bg-white">
    <div class="container-fluid">
      <router-link class="navbar-brand" :to="{name: 'events'}">
        <span class="d-flex align-items-center">
          <img width="40" src="../assets/img/logo-big.png" alt="">
          <p class="text-primary fw-medium mb-0 pb-0 mx-1">Управление техникой</p>
        </span>
      </router-link>
    </div>
  </nav>
</template>
